/* eslint-disable no-shadow, arrow-body-style */
import * as API from 'es6/core/api';

// Maintain the promises for looking up titles. This is necessary
// if multiple requests are made simultaneously (don't make the goal twice).
const getGoalIdResponses = {};

/**
 * Tries to find a user goal by title. If it can't be found, then
 * will create the goal, instead. Will also add the items to the custom
 * goal.
 *
 * Part of the benefit of using this method is that multiple requests can
 * be made without the worry of accidentally creating the same goal twice.
 *
 * @param {String} title            title of the goal
 * @param {Object} postParams       fields for creating the goal (if not found), reference API for required fields
 * @param {Object[]} items          array containing items to add to the goal
 * @param {Number} items[].itemId
 * @param {Number} items[].goalId
 * @returns {Promise}               promise containing goalId
 */
export function addToBucket(title, postParams = {}, items = []) {
  let getGoalIdResponse = getGoalIdResponses[title];

  // Create a promise that returns the goalId. If the goalId is not
  // found, get the user goals and find the appropriate goal.
  if (!getGoalIdResponse) {
    getGoalIdResponse = API.getUserCreatedGoals().then(goals => {
      const goal = goals.find(goal => goal.title === title);
      const goalParams = Object.assign({}, postParams, { title });

      if (goal) {
        return goal;
      }

      // No goal was found, so create a new one.
      return API.postGoal(goalParams);
    }).then(goal => {
      return Promise.resolve(goal.id);
    });

    getGoalIdResponses[title] = getGoalIdResponse;
  }

  return getGoalIdResponse.then(goalId => {
    return API.postCopyItemsToCustomGoal(goalId, { items });
  }).then((responses) => {
    // Return the goalId by actually returning the getGoalIdResponse
    return getGoalIdResponse;
  });
}
